import { render, staticRenderFns } from "./tabImage.vue?vue&type=template&id=39800c2c&"
import script from "./tabImage.vue?vue&type=script&lang=js&"
export * from "./tabImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports